import { Button } from "@/components/ui/Button";

interface StarterPromptsProps {
  starters: string[];
  onPick: (text: string) => void;
}

export function StarterPrompts({ starters, onPick }: StarterPromptsProps) {
  if (starters.length === 0) return null;
  return (
    <div
      className="mx-auto mt-5 grid w-full max-w-[680px] grid-cols-2 gap-3 max-[680px]:grid-cols-1"
      aria-label="Suggested questions"
    >
      {starters.slice(0, 4).map((question) => (
        <Button
          key={question}
          type="button"
          variant="ghost"
          onClick={() => onPick(question)}
          className="h-auto min-h-[64px] items-start whitespace-normal rounded-card border border-border bg-surface p-4 text-left text-[14px] leading-snug text-text shadow-sm transition-all duration-150 hover:-translate-y-[2px] hover:border-ndc-red hover:bg-ndc-red-tint hover:shadow-md focus-visible:ring-ndc-red focus-visible:ring-offset-[var(--bg)]"
        >
          {question}
        </Button>
      ))}
    </div>
  );
}
